export const ApiUrls = {
	getFolders: '/api/Folder/getList',
	getFiles: '/api/File/getList',
	getFileById: '/api/File/getById',
	getFileByPath: '/api/File/getByPath',
	getMyFolders: '/api/Folder/getMyFolders',
	getFolderSharedByUser: '/api/Folder/getSharedByUser',
	getFoldersSharedWithUser: '/api/Folder/getSharedWithUser',
	getMyFiles: '/api/file/getMyFiles',
	getFilesSharedByUser: '/api/File/getSharedByUser',
	getFilesSharedWithUser: '/api/File/getSharedWithUser',
	createFolderPermission: '/api/Folder/createFolderPermission',
	createFilePermission: '/api/File/createFilePermission',
	upload: '/api/File/upload',
	reupload: '/api/File/UpdateuploadedFile',
	download: '/api/File/download',
	delete: '/api/File/delete',
	//NEW URLS
	createReportAgrMou: '/api/Document/CreateReport',
	createReportPom: '/api/Document/CreateReportPom',

	searchAgrMou: '/api/Document/SearchInAgreementAndMemorandums',
	searchPom: '/api/Document/SearchInParticipationMinute',
	createFilter: '/api/Document/CreateFilter',
	deleteFilter: '/api/Document/DeleteFilter',
	getFilter: '/api/Document/GetFilters/',
	downloadReport: '/api/Document/ExportReport',
	getMyFoldersNames: '/api/Folder/GetMyFolders',
	createFolder: '/api/Folder/CreateFolder',
	updateFolder: '/api/Folder/UpdateFolder',
	deleteFolder: '/api/Folder/DeleteFolder',
	getfilesinfolder: '/api/Folder/GetAllFileFolders',
	deleteFileFromFolder: '/api/Folder/DeleteFileFromFolder',
	getAllFavourites: '/api/Document/GetAllFavourites',
	deleteFromFavourites: '/api/Document/DeleteFavourites',
	saveDocToFavourite: '/api/Document/SaveDocumentToFavourites',
	uploadai: '/api/DocumentProcessing/upload',
	getAllDocByType: '/api/Document/GetAllDocByType',
	getOutbox: '/api/WorkFlowDetails/GetPersonalOutbox',
	transferDocownership: '/api/WorkFlowDetails/TransferDocumentOwnership',
	getInbox: '/api/WorkFlowDetails/GetPersonalInbox',
	saveDocToFolder: '/api/Folder/CreateFileFolder',
	exportInbox: '/api/WorkFlowDetails/ExportInboxData',
	getAdminInbox: '/api/WorkFlowDetails/GetAdminInbox',
	getAdminOutbox: '/api/WorkFlowDetails/GetAdminOutbox',
	getEmployeeInbox: '/api/WorkFlowDetails/GetEmployeeInbox',
	saveToDraft: '/api/Document/SaveToDraft',
	getDraftData: '/api/Document/GetDraftData/',
	GetTasksByUser: '/api/Meeting/GetTasksByUser',
	UpdateTaskByUser: '/api/Meeting/UpdateTaskByUser',
	retryAIProcessing: '/api/DocumentProcessing/RetryAiProcessing',
	documentSoftDelete: '/api/DocumentProcessing/SoftDeleteDocumentProcessing',
	getDraftDataById: '/api/Document/GetDraftApplicationDetails/',
	changeParticipationType: '/api/DocumentProcessing/ChangeParticipationType',
	createDocument: '/api/Document/CreateDocument',
	getSubjectByDocType: '/api/Document/GetSubjectsByDocumentType',
	getSelectedDocId: '/api/Document/GetSubjectsByDocumentTypeBrowse',
	getSubjectDraftByDocType: '/api/Document/GetSubjectsDraftByDocumentType',
	getUploadedAttachments: '/api/DocumentProcessing/getUploadedAttachments',
	getUploadedPomReportAttachments: '/api/DocumentProcessing/getUploadedPomReportAttachments',
	getDraftDocuments: '/api/Document/GetDraftApplications',
	deleteDraftDocuments: '/api/Document/deleteDarftDocument',
	getDocumentObservation: '/api/Document/GetObservations',
	addUpdateObservation: '/api/Document/CreateObservations',
	addUpdateLatestDevelopment: '/api/Document/CreateLatestDevelopment',
	getLatestDevelopment: '/api/Document/GetDevelopements',
	CalenderMeetings: '/api/Meeting/CalendarMeetings',
	getAllDocuments: '/api/Document/GetAllDocument',
	deleteObservation: '/api/Document/DeleteObservations',
	deleteLatestDevelopment: '/api/Document/DeleteLatestDevelopment',
	GetMeetingParticipants: '/api/Meeting/GetParticipantNames',
	createTasks: '/api/Meeting/CreateRecommendations',
	documentLogs: '/api/Document/GetLogHistoryFile',
	taskLogs: '/api/Document/GetTaskHistoryFile',
	workflowLog: '/api/WorkFlowDetails/GetWorkflowLogs',
	uploadUpdateAttachment: '/api/DocumentProcessing/UploadUpdateAttachment',
	uploadUpdatePomReport: '/api/DocumentProcessing/UploadUpdatePomReport',
	getAllDocAttachment: '/api/DocumentProcessing/getAllDocAttachments',
	getAllDocPomReport: '/api/DocumentProcessing/getAllPomReportAttachments',
	deleteDocAttachment: '/api/DocumentProcessing/DeleteAttachment',
	deleteDocPomReport: '/api/DocumentProcessing/DeletePomReportAttachment',
	getAllSelected: '/api/Document/GetAllSubjects',
	participationNumberListOnSubject:'/api/Document/ParticipationNumberListOnSubject',
	getSelectedSubject: '/api/Document/GetDocSubjectsOfUser',
	getTaskListByDocId: '/api/Meeting/GetTasksByDocumentId',
	deleteDocument: '/api/Document/deleteDocument',
	getDeletedDocuments: '/api/Document/GetAllDeletedDocuments',
	restoreDocument: "/api/Document/RestoreDocument",
	getSharedDocument: '/api/Share/sharedDocuments',
	getSharedDocumentIds: '/api/Share/sharedDocumentIds',
	getSharedUsers: '/api/Share/shared-users',
	shareDocument: '/api/Share/shareDocument',
	revokeShareDocument: '/api/Share/revertSharedDocument',
	getDocumentSharedTemplates: '/api/Template/getDocumentSharedTemplates',
	updateDocument: '/api/Document/UpdateDocumentWithWorkflow',
	documentTranslation: '/api/Document/GetTranslationDetails',
	saveTranslation: '/api/Document/ProcessTranslationWorkflow',
	customPomReportUpload: '/api/DocumentProcessing/UploadPomReportWithTemplate',
	getPOMReportTemplate: '/api/Template/getPOMReportTemplate',
	translateDoc: '/api/Document/TranslateDocument',
	GetDocumentWorkflowRecord: '/api/WorkFlowDetails/GetWorkflowRecords',
	GetTopNotifications: '/api/WorkFlowDetails/GetTopNotifications',
	exportLogData: '/api/WorkFlowDetails/ExportLogData',
	exportdevelopment: '/api/WorkFlowDetails/ExportDevelopments',
	sharedevelopment: '/api/WorkFlowDetails/ShareDevelopmentsReport',
	shareIdentificationCard: '/api/WorkFlowDetails/ShareIdentificationcard',
	downloadDocument: '/api/Document/DownloadDocument',
	shareAdminInbox: '/api/WorkFlowDetails/ShareAdminInboxData',
	sharePersonalInbox: '/api/WorkFlowDetails/SharePersonalInboxData',
	shareReport: '/api/Document/ShareReport',
	saveLiaisonOfficers: '/api/Document/SaveLiaisonOfficers',
	saveParticipants: '/api/Document/SavePartcipantNames',
	getLiaisonOfficerById: '/api/Document/GetLiaisonOfficerByDocumentId',
	getParticipantsById: '/api/Document/GetParticipationNameByDocumentId',
	transferFileToFolder: '/api/Folder/MoveFilesToFolder',
	downloadIdentificationCard: '/api/Document/ExportIdentificationCard',
	updateIdCard: '/api/Document/UpdateIdentificationCard',
	getIdCardByDocId: '/api/Document/GetIdentificationCard',
	getDocumentProcessingStatus: '/api/DocumentProcessing/getDocumentProcessingStatus',
	exportSingleReport : '/api/Document/ExportSingleReport',
	getPOMReportTemplateById: '/api/Template/getPOMReportTemplateById',
	updateIsReadNotifications: '/api/WorkFlowDetails/UpdateIsReadNotifications',
	updateEmployee: '/api/Document/updateEmployee',
	exportTaskLogData : '/api/WorkFlowDetails/ExportTaskLogData',
}
